import dayjs from "dayjs";

/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt1@ghtk.vn on 11/08/2020.
 * @module CAMERA CONSTANTS
 */
const createBreadActionConstants = (moduleName, actionNameSuffix) => {
  return {
    browse: `${moduleName}/BROWSE/${actionNameSuffix}`,
    read: `${moduleName}/READ/${actionNameSuffix}`,
    edit: `${moduleName}/EDIT/${actionNameSuffix}`,
    add: `${moduleName}/ADD/${actionNameSuffix}`,
    delete: `${moduleName}/DELETE/${actionNameSuffix}`
  };
};
// // Action constants
export const MODULE_NAME = "CAMERA";

export const CHANGE_VIDEO_PARAM = `${MODULE_NAME}/CHANGE_VIDEO_PARAM`;
export const BROWSE_MANAGE_STATION = `${MODULE_NAME}/BROWSE_MANAGE_STATIONŚ`;
// Đầu thu
export const dvrBread = createBreadActionConstants(MODULE_NAME, "DVR");
export const videoBread = createBreadActionConstants(MODULE_NAME, "VIDEO");
export const logBread = createBreadActionConstants(MODULE_NAME, "LOG");
export const channelBread = createBreadActionConstants(MODULE_NAME, "CHANNEL");
export const moduleBread = createBreadActionConstants(MODULE_NAME, "MODULE");
export const cartBread = createBreadActionConstants(MODULE_NAME, "CART");
export const BROWSE_NETWORK = createBreadActionConstants(
  MODULE_NAME,
  "NETWORK_MANAGEMENT"
);
export const CAMERA_SETTING = createBreadActionConstants(
  MODULE_NAME,
  "CAM-SETTING"
);

// Kịch bản
export const scenarioBread = createBreadActionConstants(
  MODULE_NAME,
  "SCENARIO"
);

// Cấu hình
export const setupBread = createBreadActionConstants(MODULE_NAME, "SETUP");
export const BROWSE_DVR_BY_STATION = `${MODULE_NAME}/BROWSE_DVR_BY_STATION`;

export const CAMERA_TYPE = {
  STATION: {
    id: "STATION",
    name: "Camera Kho"
  },
  TRUCK: {
    id: "TRUCK",
    name: "Camera Xe tải"
  }
};

export const AREA_TYPE = {
  INBOUND: 1,
  INHOUSE: 2,
  OUTBOUND: 3
};
export const STATION_STATUS = {
  "0": {
    id: "0",
    label: "Tất cả",
    color: "secondary"
  },
  "1": {
    id: "1",
    label: "Có thông tin DVR",
    color: "success"
  },
  "2": {
    id: "2",
    label: "Có thông tin cấu hình",
    color: "primary"
  },
  "3": {
    id: "3",
    label: "Có dữ liệu video",
    color: "danger"
  }
};

export const ATTENDANCE_TYPE = {
  STATION: {
    id: 1,
    name: "door_time"
  },
  SECURITY: {
    id: 2,
    name: "security_time"
  },
  SUNDAY: {
    id: 3,
    name: "check_sunday_time"
  }
};

export const PAGINATION = {
  limit: 20,
  offset: 1
};

export const PROVIDER_KEY = {
  key: "NETWORK_PROVIDER"
};

export const key = "4z6C9EbGeKgNjRnTqVtYv2y5A7CaFcNf";
export const iv = "bH1SiWTMuELhuGaqtk3Y1A==";

export const appSecret = "Xtv6jsOKhHsisEAFGAdh0ZHFqybUcK1N";
export const appVector = "GAWXNUASDNVVAXYZ";

export const EFFECT_LOG_ACTIONS = {
  searchPkgOrder: "searchPkgOrder",
  watchVideo: "watchVideo"
};

export const SELECTED_TREE_NODE_TYPE = {
  ALL_NODE: 1,
  STATION_NODE: 2,
  PACKAGE_LOG_NODE: 3,
  VIDEO_NODE: 4,
  CHANNEL_NODE: 5,
  STAGE_NODE: 6
};

export const CARD_STYLE = {
  borderRadius: "0.42rem",
  boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
};

export const STATION_ID_TYPE = {
  LV: 0,
  BC: 1
};

export const TRUCK_CAMERA_STATUS = [
  {
    key: 1,
    value: "Online"
  },
  {
    key: 0,
    value: "Offline"
  }
];

export const TRUCK_CAMERA_LIVE_STATUS = [
  {
    key: 2,
    value: "Không hoạt động",
    color: "#ff0000"
  },
  {
    key: 1,
    value: "Tạm thời offline",
    color: "#ff8000"
  },
  {
    key: 4,
    value: "Online",
    color: "#069255"
  }
];

export const TRUCK_CAMERA_TYPE = [
  {
    key: "DAHUA",
    value: "Camera Dahua"
  },
  {
    key: "STREAMAX",
    value: "Camera Streamax"
  }
];

export const TRUCK_CAMERA_SUPPLIER = [
  {
    key: "DAHUA",
    value: "Camera DAHUA"
  },
  {
    key: "STREAMAX",
    value: "Camera STREAMAX"
  }
];

export const TRUCK_CAMERA_SETUP_POSITION = [
  {
    key: 1,
    value: "Cabin"
  },
  {
    key: 0,
    value: "Thùng"
  }
];

export const HAS_IMAGE = [
  {
    key: 1,
    value: "Có ảnh"
  },
  {
    key: 0,
    value: "Không có ảnh"
  }
];

export const SETUP_POSITION_DEFAULT = [
  {
    key: 0,
    value: "Camera thùng"
  },
  {
    key: 1,
    value: "Camera cabin"
  }
];

export const DVR_STATUS = {
  "1": {
    id: "1",
    name: "Online"
  },
  "0": {
    id: "0",
    name: "Init"
  },
  "-1": {
    id: "-1",
    name: "Invalid user/pass"
  },
  "-2": {
    id: "-2",
    name: "Username not found"
  },
  "-3": {
    id: "-3",
    name: "Timeout"
  },
  "-4": {
    id: "-4",
    name: "Repeat login"
  },
  "-5": {
    id: "-5",
    name: "Account is locked"
  },
  "-6": {
    id: "-6",
    name: "Account is blacklisted"
  },
  "-7": {
    id: "-7",
    name: "Insufficient resources"
  },
  "-8": {
    id: "-8",
    name: "Child connection failed"
  },
  "-9": {
    id: "-9",
    name: "Main connection failed"
  },
  "-10": {
    id: "-10",
    name: "Max connections exceeded"
  },
  "-11": {
    id: "-11",
    name: "Only support 3rd protocol"
  },
  "-12": {
    id: "-12",
    name: "Invalid USB shield"
  },
  "-13": {
    id: "-13",
    name: "No permission IP"
  },
  "-18": {
    id: "-18",
    name: "Account not initialized"
  },
  "-100": {
    id: "-100",
    name: "Other error"
  },
  "-101": {
    id: "-101",
    name: "Exception login SDK"
  },
  "-102": {
    id: "-102",
    name: "Login http failed"
  },
  "-103": {
    id: "-103",
    name: "Inactive"
  }
};
export const PROCESS_TIME = {
  level1: 3600,
  level2: 86400,
  level3: 259200
};

export const KEY_LIST_ACTIONS_CONFIG = "PKG_ORDER_MANIPULATION_FE";
export const PLACE_DEFAULT = "KHU VUC 1";
export const KEY_LIST_ACTION_TYPE_FE = "LIST_ACTION_TYPE_FE";
export const KEY_SPECIAL_PKG_ORDER_FE = "SPECIAL_PKG_ORDER_FE";
export const NO_USER_NAME = "Chưa có tài xế checkin";
export const DATE_HOURS_MINUTE_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const SOFTWARE_PLATFORM = {
  "1": {
    id: "1",
    name: "Web"
  },
  "2": {
    id: "2",
    name: "App desktop"
  },
  "3": {
    id: "3",
    name: "Android"
  },
  "4": {
    id: "4",
    name: "iOS"
  }
};

export const VIDEO_JOB_SYSTEM = {
  QLTM: {
    id: "QLTM",
    name: "QLTM"
  },
  PKG_INCIDENT: {
    id: "PKG_INCIDENT",
    name: "PACKAGE INCIDENT"
  },
  CONVEYOR: {
    id: "CONVEYOR",
    name: "CONVEYOR"
  },
  GDMS: {
    id: "GDMS",
    name: "GDMS"
  }
};

export const VIDEO_JOB_STATUS = {
  "0": {
    id: "0",
    name: "INIT"
  },
  "1": {
    id: "1",
    name: "DOWNLOAD_SUCCESS"
  },
  "2": {
    id: "2",
    name: "UPLOAD_SUCCESS"
  },
  "3": {
    id: "3",
    name: "PRIORITY_DOWNLOAD"
  },
  "4": {
    id: "4",
    name: "PUBLISHED"
  },
  "-1": {
    id: "-1",
    name: "QUERY_ERROR"
  },
  "-2": {
    id: "-2",
    name: "DOWNLOAD_TIMEOUT"
  },
  "-3": {
    id: "-3",
    name: "DOWNLOAD_ERROR"
  },
  "-5": {
    id: "-5",
    name: "CONVERT_ERROR"
  },
  "-6": {
    id: "-6",
    name: "UPLOAD_ERROR"
  },
  "-7": {
    id: "-7",
    name: "CONCAT_ERROR"
  },
  "-8": {
    id: "-8",
    name: "LOGIN_ERROR"
  }
};

export const USER_LOG_ACTION = {
  liveStreamPlay: {
    id: "liveStreamPlay",
    name: "Livestream"
  },
  playBack: {
    id: "playBack",
    name: "Playback"
  },
  downloadVideoPlayBack: {
    id: "downloadVideoPlayBack",
    name: "Download video"
  },
  capturePhoto: {
    id: "capturePhoto",
    name: "Chụp ảnh"
  },
  searchPkgOrder: {
    id: "searchPkgOrder",
    name: "Tìm kiếm đơn hàng"
  },
  watchVideo: {
    id: "watchVideo",
    name: "Xem video đơn hàng"
  },
  priorityDownloadVideo: {
    id: "priorityDownloadVideo",
    name: "Ưu tiên download video ĐH"
  },
  searchBagOrder: {
    id: "searchBagOrder",
    name: "Tìm kiếm bao hàng"
  },
  searchGreenBoxId: {
    id: "searchGreenBoxId",
    name: "Tìm kiếm hộp xanh"
  },
  lockDvr: {
    id: "lockDvr",
    name: "Khoá đầu thu"
  },
  lockTruckCamera: {
    id: "lockTruckCamera",
    name: "Khoá camera xe tải"
  },
  searchLogTruckCamCapture: {
    id: "searchLogTruckCamCapture",
    name: "Tìm kiếm ảnh chụp cam xe tải"
  },
  appLogin: {
    id: "appLogin",
    name: "Đăng nhập app camera"
  }
};
export const STATION_CAMERA_STATUS = {
  1: {
    label: "Có thông tin DVR",
    value: 1,
    color: "#bdbdbd"
  },
  2: {
    label: "Có thông tin cấu hình",
    value: 2,
    color: "#069255"
  },
  3: {
    label: "Có video",
    value: 3,
    color: "#FF6600"
  }
};
export const LOCK_FLAG = {
  open: {
    label: "Đầu thu mở",
    value: 0
  },
  lock: {
    label: "Đầu thu bị khoá",
    value: 1
  }
};

export const LOCK_FLAG_TRUCK = {
  open: {
    label: "Camera mở",
    value: 0
  },
  lock: {
    label: "Camera bị khoá",
    value: 1
  }
};

export const RANGE_PICKER_RANGES = [
  { label: 'Hôm nay', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
  { label: 'Hôm qua', value: [dayjs().subtract(1, 'days').startOf('day'), dayjs().subtract(1, 'days').endOf('day')] },
  { label: '3 ngày trước', value: [dayjs().subtract(3, 'days').startOf('day'), dayjs().endOf('day')] },
  { label: '7 ngày trước', value: [dayjs().subtract(7, 'days').startOf('day'), dayjs().endOf('day')] },
  { label: '30 ngày trước', value: [dayjs().subtract(30, 'days').startOf('day'), dayjs().endOf('day')] },
];

export const RANGE_PICKER_SHORT = [
  {label: "Hôm nay",value: [
    dayjs().startOf("day"),
    dayjs().endOf("day")]},
  {label: "Hôm qua",value: [ dayjs()
    .add(-1, "days")
    .startOf("day"),
  dayjs()
    .add(-1, "days")
    .endOf("day")]},
];

export const DATA_TYPE = ["Array", "Number", "JSON", "String"];
